import { ChangeEvent, FC, useCallback } from "react";
import { TextField } from "@mui/material";

interface CsvDownloadNameProps {
  name: string;
  onChange(name: string): void;
}

export const CsvDownloadName: FC<CsvDownloadNameProps> = ({
  name,
  onChange,
}) => {
  const nameChangeHandler = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      onChange(event.target.value);
    },
    [onChange],
  );
  return (
    <TextField
      value={name}
      onChange={nameChangeHandler}
      label="CSV Name"
      size="small"
      disabled
    />
  );
};
